<script lang="ts" setup>
import { VLoader, useThemeStore } from "@app/core";
import { computed, type Component, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import AuthLayout from "./AuthLayout.vue";
import DefaultLayout from "./DefaultLayout.vue";
import EmptyLayout from "./EmptyLayout.vue";

const layouts: Record<string, Component> = {
  default: DefaultLayout,
  auth: AuthLayout,
  empty: EmptyLayout,
};

const route = useRoute();
const router = useRouter();
const themeStore = useThemeStore();

// Track router readiness to prevent layout flash
const isRouterReady = ref(false);

// Wait for router to be ready before rendering
router.isReady().then(() => {
  isRouterReady.value = true;
});

// Initialize theme immediately (synchronous)
themeStore.initTheme();

// Dynamically resolve layout from route meta
const layout = computed(() => {
  // Don't render anything until router is ready
  if (!isRouterReady.value) return null;
  const layoutName = (route.meta?.layout as string) || "default";
  return layouts[layoutName] || layouts.default;
});
</script>

<template>
  <component
    :is="layout"
    v-if="layout"
  />
  <div
    v-else
    class="w-full min-h-screen flex justify-center items-center"
  >
    <VLoader />
  </div>
</template>
